module.exports = __webpack_public_path__ + "img/isaac.5452115a.jpeg";